//
//
//
//
//
//
//
//
var delta = 15;
export default {
  name: 'scrollBar',
  data: function data() {
    return {
      top: 0
    };
  },
  methods: {
    handleScroll: function handleScroll(e) {
      var eventDelta = e.wheelDelta || -e.deltaY * 3;
      var $container = this.$refs.scrollContainer;
      var $containerHeight = $container.offsetHeight;
      var $wrapper = this.$refs.scrollWrapper;
      var $wrapperHeight = $wrapper.offsetHeight;

      if (eventDelta > 0) {
        this.top = Math.min(0, this.top + eventDelta);
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top;
          } else {
            this.top = Math.max(this.top + eventDelta, $containerHeight - $wrapperHeight - delta);
          }
        } else {
          this.top = 0;
        }
      }
    }
  }
};